module.exports = __webpack_public_path__ + "521d749947646ab5f46972b11a9b3000.png";